<template>
  <div>
    <Editor></Editor>
  </div>
</template>

<script>
export default {
  components: {
    Editor: require('../../age/page/Editor.vue').default
  }
}
</script>

<style scoped>

</style>
